<header class="header">
  <h1 class="header__title" translate="verification.routing.express"></h1>
  <btn
    [link]="true"
    (action)="promptSkip()"
    buttonText="common.btn.later"
    class="header__skip"
  ></btn>
</header>
<card-wrapper>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" method="POST" novalidate>
    @if (isEmailSent | async) {
      <pac-alert
        class="alert"
        type="positive"
        [iconVisible]="false"
      >
        <span translate="verification.basic.email.pending.title"></span>
        <span [innerHTML]="'verification.basic.email.pending.text' | translate: { email: isEmailSent | async }"></span>
      </pac-alert>
    }
    <p [innerHTML]="'verification.steps' | translate: { stepsTotal: 2, currentStep: 2 }"></p>
    <h2 class="title" translate="verification.basic.email.title"></h2>
    <p class="subtitle"  translate="verification.basic.email.text"></p>

    @let ctx = { focus: false, control: form.get('email'), field: 'email' };
    @if (ctx) {
      <app-form-field
        [isControlTouched]="ctx.control.touched"
        [errors]="ctx.control.errors"
        [errorTexts]="fieldErrors[ctx.field]"
        [submitErrors]="submitErrors.asObservable()">

        <label for="email"
               translate="email-confirmation.field.e-mail-label"
               [class.fade-in]="ctx.control.value || ctx.focus"></label>
        <input type="email" maxlength="256"
               class="form-control"
               id="email"
               formControlName="email"
               autocomplete="email"
               name="Email"
               [placeholder]="ctx.focus ? '' : 'email-confirmation.field.e-mail-placeholder' | translate"
               (focus)="ctx.focus = true" (blur)="ctx.focus = false"/>
      </app-form-field>
    }
    <btn
      type="submit"
      [loading]="(isPending$ | async)!"
      [disabled]="(isFrozen$ | async)!"
    >
      @if ((isFrozen$ | async) === false && (isPending$ | async) === false) {
        <span translate="verification.basic.email.button"></span>
      } @else {
        <countdown-timer
          *ngIf="(isFrozen$ | async) && countdownTimer"
          [template]="'verification.basic.email.countdown'"
          [countdown]="countdownTimer"
          (complete)="isFrozen$.next(false)">
        </countdown-timer>
      }
    </btn>
  </form>
</card-wrapper>
